import { render, staticRenderFns } from "./MessageTemplateDialog.vue?vue&type=template&id=40f453e8&scoped=true"
import script from "./MessageTemplateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateDialog.vue?vue&type=style&index=0&id=40f453e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f453e8",
  null
  
)

export default component.exports